const { registerBlockType } = window.wp.blocks;

const { 
    RichText,
    InspectorControls,
    ColorPalette,
    MediaUpload,
    InnerBlocks
} = window.wp.editor;

const { 
    PanelBody, 
    IconButton, 
    RangeControl, 
    TextControl
} = window.wp.components;

const ALLOWED_BLOCKS = ['custom-gutenberg/hero-slide'];

if ( window.wp.ajax ) {
    registerBlockType('custom-gutenberg/hero-slider', {
        // built-in attributes
        title: 'Hero Slider',
        description: 'Custom Hero Slider',
        icon: 'slides',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            slides: {
                type: 'number',
                default: '1'
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                slides
            } = attributes;

            // custom functions
            function onSlidesChange (slides) {
                setAttributes({slides: slides});
            };


            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Number of Slides' }>
                        <RangeControl
                            label={ 'Slides' }
                            value={ slides }
                            onChange={ onSlidesChange }
                            min={ 1 } 
                            max={ 4 } 
                            step={ 1 } 
                            />
                    </PanelBody>
                </InspectorControls>
                ,
                <div class="container-fluid position-relative">
                    <div id="hero-slider" class="keen-slider rounded bg-light shadow mb-4" style={ { opacity: '1' } }>
                        <InnerBlocks allowedBlocks={ ALLOWED_BLOCKS } />
                    </div>
                    <div class="keen-slider__arrows">
                        <div data-dir="prev"><i
                                class="la la-arrow-left la-2x p-2"></i></div>
                        <div data-dir="next"><i
                                class="la la-arrow-right la-2x p-2"></i></div>
                    </div>
                </div>
            ]
            );
        },

        save({ attributes }) {

            const {
                slides
            } = attributes;

            return (
                <div class="container-fluid position-relative">
                    <div id="hero-slider" class="keen-slider keen-slider__fade rounded bg-light shadow mb-4">
                        <InnerBlocks.Content />
                    </div>
                    <div class="keen-slider__arrows">
                        <div data-dir="prev"><i
                                class="la la-arrow-left la-2x p-2"></i></div>
                        <div data-dir="next"><i
                                class="la la-arrow-right la-2x p-2"></i></div>
                    </div>
                </div>
            );
        },
    });
}